import { render, staticRenderFns } from "./packed.vue?vue&type=template&id=e97c4444&scoped=true"
import script from "./packed.vue?vue&type=script&lang=js"
export * from "./packed.vue?vue&type=script&lang=js"
import style0 from "./packed.vue?vue&type=style&index=0&id=e97c4444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c4444",
  null
  
)

export default component.exports